// import Vue from 'vue'
// import '@/utils/request'
import '@/assist/permission' // 权限控制
import 'sky-engine/pages/app/index'
import '@/router'
import '@/lang'
import '@/assets/styles/index.scss' // global css
import Vue from 'vue'
import VueAMap from 'vue-amap'

import * as filters from '@/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// if (process.env.NODE_ENV !== 'production') {
//   require('../../mock')
// }

// 引入vue-amap

Vue.use(VueAMap)

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '4d07931be095a7f16c8201249b59dbf1',
  // 插件集合
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'MarkerClusterer'
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
})

require('../../mock')
